module.exports = __webpack_public_path__ + "img/motor_no36.62f25fc6.jpg";